import intl from 'react-intl-universal'

import orderTypes from './orderTypes'

export function PicklistController(
  $location,
  { picklistId },
  metaTemplatesService,
  settingsService,
  $scope,
  toastr,
  $rootScope,
  picklistService
) {
  const { picklists } = $scope.$resolve.initialPicklistLoad
  this.picklist = {
    ...(picklists[picklistId] || {}),
    // give each item an ellipsis prop, purely for ui state
    // makes it easier to remove this prop when we need to save to dynamo
    picklist: (picklists[picklistId] || { picklist: [] }).picklist.map(
      (p, i) => ({
        ...p,
        ellipsis: { index: i, editing: false, dragging: false },
      })
    ),
  }
  // controls modal state for delete confirm
  this.modalIsActive = false
  // expose order types to view
  this.orderTypes = orderTypes
  // maps to order type dropdown
  this.orderType =
    picklists[picklistId] && typeof picklists[picklistId].orderType === 'number'
      ? picklists[picklistId].orderType
      : 2
  // expose render types to view
  this.renderTypes = ['single', 'freeText']
  // maps to render type dropdown
  this.renderType =
    (picklists[picklistId] || {}).renderType || this.renderTypes[0]
  // Input default freeText setting into scope.
  this.freeText = this.renderType !== 'single'
  // exposes label for vm (doesnt responsible for any logic really)
  this.field =
    (metaTemplatesService.getMetaItems()[picklistId] || {}).label || picklistId
  // which item is being dragged
  this.currentDrag = null

  this.intl = intl

  this.add = () => {
    this.picklist.picklist = [
      {
        der: 0,
        text: '',
        id: '',
        default: false,
        active: true,
        ellipsis: { index: 0, editing: true, dragging: false },
      },
      ...this.picklist.picklist.map((p) => ({
        ...p,
        order: p.order + 1,
      })),
    ]
    return this.picklist.picklist
  }

  this.back = () => $location.path('/settings')

  this.callModal = () => {
    this.modalIsActive = true
    $rootScope.$broadcast('DISPATCH', { type: 'OVERLAY_SHOW' })
  }

  // pass this callback to modal confirm button
  this.confirmDeletePicklist = () => {
    const data = this.preDelete()
    this.modalIsActive = false
    settingsService
      .saveCompanySettings('picklists', data)
      .then(() => {
        toastr.success(intl.get('picklist.confirmDeletePicklist.success'))
      })
      .catch(() =>
        toastr.error(intl.get('picklist.confirmDeletePicklist.error'))
      )
    // todo: daniel: add whatever angela wants to happen here
    // https://arcpublishing.atlassian.net/browse/EL-179?focusedCommentId=28931&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-28931
  }

  this.dismissModal = () => {
    this.modalIsActive = false
    return this.modalIsActive
  }

  this.isEditingPicklist = () =>
    !!this.picklist.picklist.find((o) => o.ellipsis.editing)

  // closes input if you dont click on it
  this.handleClick = ({ target }) => {
    // hacky
    if (
      target.nodeName !== 'INPUT' &&
      !/edit|save|add\spicklist\sitem/i.test(target.textContent.trim())
    ) {
      // dont resort when invalid or when NOT editing
      if (!this.validate() || !this.isEditingPicklist()) return

      // closes input and sort picklists if you click outside
      this.picklist.picklist = this.picklist.picklist
        .map((p) => ({
          ...p,
          ellipsis: { ...p.ellipsis, editing: false },
        }))
        .sort(orderTypes[this.orderType].sort)
    }
  }

  this.preDelete = () => ({
    picklists: Object.keys({
      ...picklists,
      [picklistId]: this.picklist,
    }).reduce((acc, k) => {
      return k !== picklistId
        ? { ...acc, [k]: picklists[k] }
        : // set some default and empty array, don't delete the object
          { ...acc, [k]: { picklist: [], orderType: 2 } }
    }, {}),
  })

  this.preSave = () => {
    return picklistService.preSave(
      picklistId,
      picklists,
      this.picklist,
      this.orderType
    )
  }

  this.removeItem = (i) => this.picklist.picklist.splice(i, 1)

  this.reorder = (from, to) => {
    // handle invalid sort to
    if (to < 0) return

    this.picklist.picklist.splice(
      to,
      0,
      this.picklist.picklist.splice(from, 1).pop()
    )
    this.picklist.picklist.forEach((p, order) => {
      p.order = order
      p.ellipsis.index = order
    })
    this.orderType = 4
  }

  this.toggleFreeText = () => {
    if (this.renderType === 'single') {
      this.renderType = 'freeText'
      this.freeText = true
    } else {
      this.renderType = 'single'
      this.freeText = false
    }
  }
  this.applyRenderTypes = (preSaveData) =>
    picklistService.applyRenderType(preSaveData, picklistId, this.renderType)

  this.save = () => {
    if (!this.validate()) return
    // clean it up first, remove ellipsis ui state
    // we have to send all picklists, not just the current one
    const data = this.applyRenderTypes(this.preSave())
    settingsService
      .saveCompanySettings('picklists', data)
      .then(() => {
        toastr.success(intl.get('picklist.save.success'))
      })
      .catch(() => toastr.error(intl.get('picklist.save.error')))
  }

  this.setDefault = (index) => {
    if (this.picklist.picklist[index].active === false) {
      return toastr.error(intl.get('picklist.setDefault.error'))
    }
    this.picklist.picklist = this.picklist.picklist.map((p, i) => {
      if (index === i) {
        return { ...p, default: !p.default }
      } else {
        return { ...p, default: false }
      }
    })
  }

  this.setDraggable = (index) => {
    this.currentDrag = index
    this.picklist.picklist = this.picklist.picklist.map((p, i) => {
      return index === i
        ? { ...p, ellipsis: { ...p.ellipsis, dragging: true } }
        : { ...p, ellipsis: { ...p.ellipsis, dragging: false } }
    })
  }

  // sets order type for all items
  // comes from orderTypes file
  // always need to set ellipsis index which is
  // just convenient way to pass array position
  // to drag/drop directive
  this.setOrderType = (ordertype) => {
    this.picklist.picklist = this.picklist.picklist
      .sort(this.orderTypes[ordertype].sort)
      .map((p, i) => ({
        ...p,
        ellipsis: {
          ...p.ellipsis,
          index: i,
        },
      }))
  }

  this.toggleActive = (i) => {
    if (this.picklist.picklist[i].default !== true) {
      this.picklist.picklist[i].active = !this.picklist.picklist[i].active
    } else {
      toastr.error(intl.get('picklist.toggleActive.error'))
    }
  }

  // toggles in-place editing for text/id cells
  this.toggleEdit = (i) => {
    this.picklist.picklist[i].ellipsis.editing = !this.picklist.picklist[i]
      .ellipsis.editing
  }

  // prevents dupe picklist items, which will screw with select dropdown
  // also prevents empty text/id
  this.validate = () => picklistService.validate(this.picklist)
}

export default [
  '$location',
  '$routeParams',
  'metaTemplatesService',
  'settingsService',
  '$scope',
  'toastr',
  '$rootScope',
  'picklistService',
  PicklistController,
]
